import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const InventoryTable = ({ data, columns, title, colors }) => {
  const theme = useTheme();
  return (
    <Box sx={{ height: 400, width: '70%' }}>
      <Typography variant="h6" mb={2} fontWeight="bold"  color={colors?.blueAccent?.[500] || "#1976d2"}>
        {title}
      </Typography>

      <DataGrid
        rows={data.map((item, index) => ({ id: index, ...item }))}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[5, 10, 20]}
        sx={{
          '& .MuiDataGrid-root': {
            border:` ${0}  !important`,
          },
          '& .MuiDataGrid-cell': {
            // borderBottom: 'none !important',
          },
          '& .MuiDataGrid-columnHeaders': {
            borderBottom: 'none',
          },
          '& .MuiDataGrid-columnSeparator': {
            display: 'none !important',
          },
          '& .MuiDataGrid-footerContainer': {
            borderTop: 'none',
          },
          // تنسيقات إضافية
          '& .MuiDataGrid-virtualScroller': { 
            backgroundColor: colors?.primary?.[400] || "#1e293b",
                    },
          '& .MuiDataGrid-toolbarContainer': {
            '& .MuiButton-text': {
              color: colors?.greenAccent?.[200] || "#66bb6a",
            },
          },
          "& .MuiCheckbox-root": { color: `${colors.greenAccent[200]} !important` },
        }}
        // disableSelectionOnClick
        checkboxSelection
        // components={{ Toolbar: GridToolbar }}
      />
    </Box>
  );
};

export default InventoryTable;